import React from "react";

const StripeRefresh = () => (
  <div className="flex flex-col items-center justify-center h-screen text-center">
    <h1 className="text-2xl font-semibold text-yellow-600 mb-3">
      ⚠️ Stripe Onboarding Incomplete
    </h1>
    <p className="text-gray-700">
      It seems you didn’t finish connecting your Stripe account. Please try again from the wallet page.
    </p>
  </div>
);

export default StripeRefresh;
